import { Search } from '@/DTOS/SystemType/Search';
import request from '../../utils/request';

const SystemTypeService = {
  search: (search: Search) => {
    return request('/systemType/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; operations: any; isActive: any; deviceTypeId: any; model: any; pieces: any; }} */ formData: {
      name: any;
      operations: any;
      isActive: any;
    }
  ) => {
    return request('/systemType/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          operations: formData.operations,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default SystemTypeService;
